import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useCopyToClipboard } from "react-use";
import { Field } from "formik";
import { CopyButton, CopyText, FieldBorder, Input, CopiedIndicator, } from "./styles";
import { FloatingFieldLabel } from "../atoms/FloatingFieldLabel";
import { FlexRowCenter } from "../../box";
import { Label } from "../atoms/Label";
import { Icon } from "../../icon";
/**
 * Read-only text field with copy-to-clipboard functionality.
 * Displays a value that users can copy but not edit.
 *
 * @example
 * ```tsx
 * <TextFieldWithCopy
 *   name="apiUrl"
 *   label="API URL"
 * />
 * ```
 */
export const TextFieldWithCopy = ({ name, label }) => {
    const [, copyToClipboard] = useCopyToClipboard();
    const [focused, setFocused] = useState(false);
    const [copied, setCopied] = useState(false);
    return (_jsx(Field, { name: name, children: ({ field }) => {
            const isFilled = Boolean(field.value);
            const handleCopy = () => {
                copyToClipboard(field.value);
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            };
            return (_jsxs(Label, { children: [_jsx(FloatingFieldLabel, { visible: isFilled, children: label }), _jsxs(FlexRowCenter, { children: [_jsx(Input, { type: "text", ...field, readOnly: true, placeholder: label, onFocus: () => setFocused(true), onBlur: () => setFocused(false) }), copied ? (_jsxs(CopiedIndicator, { children: [_jsx(Icon, { name: "check-circle", size: 16 }), "Copied"] })) : (_jsxs(CopyButton, { type: "button", onClick: handleCopy, children: [_jsx(Icon, { name: "duplicate", size: 18 }), _jsx(CopyText, { children: "Copy" })] }))] }), _jsx(FieldBorder, { focused: focused })] }));
        } }));
};
